<template>
  <div class="genders-chart-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">
          <i class="fas fa-venus-mars title-icon"></i>
          Gênero
        </h3>
        <p class="card-subtitle">Total de Residentes por Gênero</p>
      </div>
    </div>

    <div class="card-content">
      <ErrorsMessages :errors="errors" />

      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <div class="genders-list">
          <div
            v-for="(gender, key) in genders"
            :key="key"
            class="gender-item"
            :class="`gender-${gender.name.toLowerCase()}`"
          >
            <div class="gender-info">
              <div class="gender-icon">
                <i :class="getGenderIcon(gender.name)"></i>
              </div>
              <div class="gender-details">
                <span class="gender-name">{{
                  String(gender.name).toUpperCase()
                }}</span>
                <div class="gender-progress">
                  <div
                    class="progress-bar"
                    :class="`progress-${gender.name.toLowerCase()}`"
                    :style="{ width: getPercentage(gender.total) + '%' }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="gender-stats">
              <span class="gender-count">{{ gender.total }}</span>
              <span class="gender-percentage"
                >{{ getPercentage(gender.total) }}%</span
              >
            </div>
          </div>
        </div>

        <!-- Summary -->
        <div class="gender-summary">
          <div class="summary-header">
            <h4 class="summary-title">
              <i class="fas fa-users mr-2"></i>
              Resumo
            </h4>
          </div>
          <div class="summary-content">
            <div class="summary-item">
              <span class="summary-label">Total de Residentes</span>
              <span class="summary-value">{{ totalResidents }}</span>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import api from "../../services/api";

export default {
  name: "Genders",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      genders: [],
      errors: [],
      loading: false,
    };
  },
  computed: {
    totalResidents() {
      return this.genders.reduce((total, gender) => total + gender.total, 0);
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    getGenderIcon(genderName) {
      const name = genderName.toLowerCase();
      if (name === "feminino") return "fas fa-venus";
      if (name === "masculino") return "fas fa-mars";
      return "fas fa-user";
    },
    getPercentage(count) {
      if (this.totalResidents === 0) return 0;
      return Math.round((count / this.totalResidents) * 100);
    },
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/graphics/genders");

        const { genders, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.genders = genders;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.genders-chart-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  height: fit-content;
}

.card-header {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  padding: 20px;
  border-bottom: 1px solid #818cf8;
}

.header-content {
  text-align: center;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #3730a3;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #4338ca;
  margin-right: 8px;
  font-size: 16px;
}

.card-subtitle {
  color: #3730a3;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.card-content {
  padding: 24px;
}

.loading-overlay {
  border-radius: 12px;
  min-height: 200px;
}

/* Genders List */
.genders-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.gender-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.gender-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.gender-feminino {
  background: linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%);
  border-color: #f9a8d4;
}

.gender-masculino {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #93c5fd;
}

.gender-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.gender-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
}

.gender-feminino .gender-icon {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
}

.gender-masculino .gender-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.gender-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gender-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.gender-progress {
  width: 100%;
  height: 6px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.8s ease;
  border-radius: 3px;
}

.progress-feminino {
  background: linear-gradient(90deg, #ec4899 0%, #db2777 100%);
}

.progress-masculino {
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
}

.gender-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.gender-count {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.gender-percentage {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Summary */
.gender-summary {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.summary-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.summary-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.summary-title i {
  color: #0f65b0;
}

.summary-content {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
}

/* Responsive Design */
@media (max-width: 768px) {
  .card-content {
    padding: 16px;
  }

  .card-header {
    padding: 16px;
  }

  .gender-item {
    padding: 16px;
  }

  .gender-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .gender-count {
    font-size: 20px;
  }

  .gender-summary {
    padding: 16px;
  }

  .summary-content {
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .card-title {
    font-size: 16px;
    flex-direction: column;
    gap: 4px;
  }

  .card-subtitle {
    font-size: 13px;
  }

  .gender-item {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .gender-info {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .gender-stats {
    align-items: center;
  }

  .summary-item {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .summary-value {
    font-size: 18px;
  }
}
</style>